var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab"},[_c('div',{staticClass:"tab-box"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,class:[_vm.tabIndex == index ? 'active' : ''],on:{"click":function($event){return _vm.selectTab(index)}}},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }